import React from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"

/* Images */
import step1 from "../../../assets/images/icons-steps/Póntelo.svg"
import step2 from "../../../assets/images/icons-steps/úsalos.svg"
import step3 from "../../../assets/images/icons-steps/Lávalo.svg"
import step4 from "../../../assets/images/icons-steps/Grupo 7250.svg"
import step5 from "../../../assets/images/icons-steps/Usa.svg"
import imgHowUse from "../../../assets/images/img-how-use.png"
import imgHowUse_cl from "../../../assets/images/img-how-use-cl.png"

import "./how-use-product.scss"

const HowUseProduct = ({ mobile , flujoType}) => {
  const steps = [
    {
      id: 1,
      image: step1,
      title: "1. Póntelo",
      description: (
        <p className="f-description-step">
          {" "}
          Usa tu{" "}
          {process.env.LOCALE === "es-BO"
            ? "ropa interior Íntima Wear"
            : process.env.LOCALE === "es-CL"
            ? "calzón"
            : "panty"}{" "}
          <b>desde el primer día</b> de tu período.
        </p>
      ),
    },
    {
      id: 2,
      image: step2,
      title: "2. Cámbialo",
      description: (
        <p className="f-description-step">
          {process.env.LOCALE === "es-CL" ? (
            <>
              Te recomendamos que después de pasadas {flujoType === 'Abundante' ? 12 : 8-10 } horas de uso, cambies
              tu calzón. Por lo que sería ideal que tengas dos para que puedas
              reemplazarlo y usar Intimawear durante todo tu periodo
            </>
          ) : (
            <>
              Después de pasadas {flujoType === 'Abundante' ? 12 : 8-10 } horas de uso, cámbialo. Si estas fuera
              de casa, mételo en su empaque especial{" "}
              <b>completamente sellado</b> y guárdalo en tu bolso sin problema.
            </>
          )}
        </p>
      ),
    },
    {
      id: 3,
      image: step3,
      title: "3. Lávalo",
      description: (
        <p className="f-description-step">
          A mano <b>con agua fría</b> y luego, para eliminar cualquier residuo,
          vuelve a lavarlo en la lavadora. ¡No uses suavizante ni blanqueador!
        </p>
      ),
    },
    {
      id: 4,
      image: step4,
      title: "4. Déjalo secar",
      description: (
        <p className="f-description-step">
          <b>Al aire libre</b> (no lo metas a la secadora). Es posible que seque
          un poco más despacio que{" "}
          {process.env.LOCALE === "es-CL"
            ? "la ropa interior normal."
            : "un panty normal."}
        </p>
      ),
    },
    {
      id: 5,
      image: step5,
      title: `5. Usa + Lava + Reusa ${
        process.env.LOCALE !== "es-CL" ? "y cuida el planeta" : ""
      }`,
      description: (
        <p className="f-description-step">
          Vuelve a usarlo cuando <b>esté completamente seco.</b> ¿Ves? ¡Es muy
          fácil!
        </p>
      ),
    },
  ]

  return (
    <section className="f-container-how-use-product">
      <div className="f-content-wrapper">
        <img
          src={process.env.LOCALE === "es-CL" ? imgHowUse_cl : imgHowUse}
          className="f-how-use-img"
        />
        <div className="f-content-how-use">
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={mobile ? "Cómo usarlos" : "Cómo usarlos en 5 pasos"}
          />
          <div className="f-container-steps-how-use">
            {steps.map(step => (
              <div className="f-step-how" key={step.id}>
                <div className="f-step-image">
                  <img src={step.image} alt={step.title} />
                </div>
                <div className="f-container-description-step">
                  <p className="f-title-step">{step.title}</p>
                  {step.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowUseProduct
